import React, { useEffect, createElement } from 'react';
import { Hero } from '../components/landing/Hero';
import { ProblemSection } from '../components/landing/ProblemSection';
import { ResearchSection } from '../components/landing/ResearchSection';
import { Ingredients } from '../components/landing/Ingredients';
import { HowItWorks } from '../components/landing/HowItWorks';
import { Testimonials } from '../components/landing/Testimonials';
import { DoctorProfile } from '../components/landing/DoctorProfile';
import { Pricing } from '../components/landing/Pricing';
import { Footer } from '../components/landing/Footer';
export function LandingPage() {
  useEffect(() => {
    // Set page title
    document.title = 'Finally Sleep Through The Night Without A Single Bathroom Trip';
    // Set meta description for URL preview
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Finally Sleep Through The Night Without A Single Bathroom Trip - The European vein tonic protocol that releases the Pelvic Pressure Trap.');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = 'Finally Sleep Through The Night Without A Single Bathroom Trip - The European vein tonic protocol that releases the Pelvic Pressure Trap.';
      document.head.appendChild(meta);
    }
    // Set Open Graph title for social media previews
    let ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) {
      ogTitle.setAttribute('content', 'Finally Sleep Through The Night Without A Single Bathroom Trip');
    } else {
      ogTitle = document.createElement('meta');
      ogTitle.setAttribute('property', 'og:title');
      ogTitle.setAttribute('content', 'Finally Sleep Through The Night Without A Single Bathroom Trip');
      document.head.appendChild(ogTitle);
    }
    // Set Open Graph description
    let ogDescription = document.querySelector('meta[property="og:description"]');
    if (ogDescription) {
      ogDescription.setAttribute('content', 'The European vein tonic protocol that releases the Pelvic Pressure Trap so your bladder stays calm until morning.');
    } else {
      ogDescription = document.createElement('meta');
      ogDescription.setAttribute('property', 'og:description');
      ogDescription.setAttribute('content', 'The European vein tonic protocol that releases the Pelvic Pressure Trap so your bladder stays calm until morning.');
      document.head.appendChild(ogDescription);
    }
    // Set Twitter Card title
    let twitterTitle = document.querySelector('meta[name="twitter:title"]');
    if (twitterTitle) {
      twitterTitle.setAttribute('content', 'Finally Sleep Through The Night Without A Single Bathroom Trip');
    } else {
      twitterTitle = document.createElement('meta');
      twitterTitle.setAttribute('name', 'twitter:title');
      twitterTitle.setAttribute('content', 'Finally Sleep Through The Night Without A Single Bathroom Trip');
      document.head.appendChild(twitterTitle);
    }
  }, []);
  return <div className="min-h-screen font-sans text-slate-900 bg-white selection:bg-emerald-100 selection:text-emerald-900" data-id="element-350">
      <Hero data-id="element-351" />
      <ProblemSection data-id="element-352" />
      <ResearchSection data-id="element-353" />
      <Ingredients data-id="element-354" />
      <HowItWorks data-id="element-355" />
      <Testimonials data-id="element-356" />
      <DoctorProfile data-id="element-357" />
      <Pricing data-id="element-358" />
      <Footer data-id="element-359" />
    </div>;
}